// https://developers.google.com/youtube/iframe_api_reference
export default function () {
    const init = async function () {
        return new Promise((resolve) => {
            if (window.YT) {
                // console.log('YouTube Player API already exists');
                resolve(true);
            }

            const tag = document.createElement('script');
            tag.src = 'https://www.youtube.com/iframe_api';
            const firstScriptTag = document.getElementsByTagName('script')[0];
            firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

            window.onYouTubeIframeAPIReady = function () {
                // console.log('YouTube Player API ready');
                resolve(true);
            };
        });
    };

    let player = null;

    const attachPlayer = function (id, onPlayerUpdate) {
        if (!window.YT) return null;
        if (player) return true;
        player = new window.YT.Player(id, {
            events: {
                onReady: () => {
                    onPlayerUpdate(getPlayerStateReadable());
                },
                onStateChange: () => {
                    onPlayerUpdate(getPlayerStateReadable());
                },
            },
        });
        return player;
    };

    function getPlayerCurrentTime() {
        if (!player?.getCurrentTime) return null;
        return player.getCurrentTime();
    }

    function getPlayerStateReadable() {
        if (!player) return null;
        switch (player.getPlayerState()) {
            case -1:
                return 'unstarted';
            case 0:
                return 'ended';
            case 1:
                return 'playing';
            case 2:
                return 'paused';
            case 3:
                return 'buffering';
            case 5:
                return 'cued';
            default:
                return 'unknown';
        }
    }

    function playVideo() {
        if (!player) return null;
        player.playVideo();
    }

    function pauseVideo() {
        if (!player) return null;
        player.pauseVideo();
    }

    function seekTo(seconds) {
        if (!player) return null;
        player.seekTo(seconds);
    }

    return {init, attachPlayer, getPlayerCurrentTime, getPlayerStateReadable, playVideo, pauseVideo, seekTo};
}
